import store from "@/store";
import moment from "moment";
import { G_FILE_COMPRESSION } from "@/constants";
//import exifr from "exifr/dist/lite.esm.mjs";
import pLimit from "p-limit";
import heic2any from "heic2any";

const limit = pLimit(1);
let count = 0;

export async function preparePreview(formData, mode) {
  count = 0;
  const promises = formData.map((x) =>
    limit(() =>
      readNewFile(x, mode).then((img) => ({
        err: img.err,
        id: x.id,
        num: x.num,
        name: x.name,
        cropped: img.dPct < 500 ? true : x.cropped, // če je izrez minimalen, štejemo, da je izrezana
        src: img.image,
        srcSize: img.image.length * 2, // velikost base64 url stringa
        file: formData[0],
        aspectRatio: x.aspectRatio,
        aspectRatioStore: x.aspectRatioStore,
        srcThumb: img.thumb,
        cropPxNum: img.dPct,
        exif: x.exif,
        orientation: x.orientation,
        width: x.width, // originalWidth
        height: x.height,
        sWidth: x.sWidth, // storeWidth
        sHeight: x.sHeight,
        cWidth: x.cWidth, // croppedWidth
        cHeight: x.cHeight,
        qualityPct: x.qualityPct,
        size: x.size,
        type: x.type,
        lastModified: x.lastModified,
        selectedFormat: x.selectedFormat,
        selectedFormatFile: x.selectedFormatFile,
        selectedPaperType: x.selectedPaperType,
        selectedPaperTypeFile: x.selectedPaperTypeFile,
        selectedCopies: x.selectedCopies,
        selectedFitIn: x.selectedFitIn,
        selectedWhiteBorder: x.selectedWhiteBorder,
        selectedPrintDate: x.selectedPrintDate,
        selectedAutoCorrection: x.selectedAutoCorrection,
        scaleX: x.scaleX,
        scaleY: x.scaleY,
      }))
    )
  );
  return await Promise.all(promises).catch((err) => {
    // eslint-disable-next-line no-console
    console.log(err);
  });
}

/* FOR IMAGE TEMPLATES CROPPING */
export async function readNewSimpleFile(file) {
  return new Promise((resolve, reject) => {
    try {
      let fReader = new FileReader();
      fReader.readAsArrayBuffer(file);

      fReader.onerror = () => {
        reject(fReader.error);
      };

      fReader.onload = async () => {
        let img = new Image();
        img.crossOrigin = '*';

        let iFile = "";
        if ((file.name.toLowerCase().indexOf('.heic') !== -1) || (file.name.toLowerCase().indexOf('.heif') !== -1)) {
          let blobURL = URL.createObjectURL(file);
          let blobRes = await fetch(blobURL)
          let blob = await blobRes.blob()
          try { // nekatere heic imajo type že image/jpeg, zato ob spodleteli konverziji obravnavamo kot navaden fajl
            iFile = await heic2any({
              blob,
              toType: "image/jpeg",
              quality: G_FILE_COMPRESSION
            });
          } catch (error) {
            iFile = new Blob([fReader.result], { type: file.type });
          }
        } else
          iFile = new Blob([fReader.result], { type: file.type });

        img.src = URL.createObjectURL(iFile);
        URL.revokeObjectURL(iFile);
        delete fReader.result;

        img.onload = function () {
          file.width = img.width;
          file.height = img.height;
          file.aspectRatio = file.width / file.height;
          file.cropped = false;
          file.scaleX = 1;
          file.scaleY = 1;

          file.orientation =
            file.width >= file.height ? "landscape" : "portrait";

          resolve(setNewSimpleCanvasImage(img, file.width, file.height, file.type));
        };
      };
    } catch (error) {
      // eslint-disable-next-line no-console
      console.error(error);
      reject(error);
    }
  });
}

/* FOR ADD EXTRA SINGLE IMAGE TEMPLATES CROPPING */
export async function readNewSimpleExtraFile(file) {
  return new Promise((resolve, reject) => {
    try {
      let fReader = new FileReader();
      fReader.readAsArrayBuffer(file);

      fReader.onerror = () => {
        reject(fReader.error);
      };

      fReader.onload = async () => {
        let img = new Image();
        img.crossOrigin = '*';

        let iFile = "";
        if ((file.name.toLowerCase().indexOf('.heic') !== -1) || (file.name.toLowerCase().indexOf('.heif') !== -1)) {
          let blobURL = URL.createObjectURL(file);
          let blobRes = await fetch(blobURL)
          let blob = await blobRes.blob()
          try { // nekatere heic imajo type že image/jpeg, zato ob spodleteli konverziji obravnavamo kot navaden fajl
            iFile = await heic2any({
              blob,
              toType: "image/jpeg",
              quality: G_FILE_COMPRESSION
            });
          } catch (error) {
            iFile = new Blob([fReader.result], { type: file.type });
          }
        } else
          iFile = new Blob([fReader.result], { type: file.type });

        img.src = URL.createObjectURL(iFile);
        URL.revokeObjectURL(iFile);
        delete fReader.result;

        img.onload = function () {
          file.width = img.width;
          file.height = img.height;
          file.aspectRatio = file.width / file.height;
          file.cropped = false;
          file.scaleX = 1;
          file.scaleY = 1;

          file.orientation =
            file.width >= file.height ? "landscape" : "portrait";

          resolve(setNewSimpleCanvasExtraImage(img, file));
        };
      };
    } catch (error) {
      // eslint-disable-next-line no-console
      console.error(error);
      reject(error);
    }
  });
}

/* FOR CREATING IMAGE DATABSE PREVIEW */
export async function readNewImageDatabaseFile(file) {
  return new Promise((resolve, reject) => {
    try {
      let fReader = new FileReader();
      fReader.readAsArrayBuffer(file);

      fReader.onerror = () => {
        reject(fReader.error);
      };

      fReader.onload = async () => {
        let img = new Image();
        img.crossOrigin = '*';

        let iFile = "";
        if ((file.name.toLowerCase().indexOf('.heic') !== -1) || (file.name.toLowerCase().indexOf('.heif') !== -1)) {
          let blobURL = URL.createObjectURL(file);
          let blobRes = await fetch(blobURL)
          let blob = await blobRes.blob()
          try { // nekatere heic imajo type že image/jpeg, zato ob spodleteli konverziji obravnavamo kot navaden fajl
            iFile = await heic2any({
              blob,
              toType: "image/jpeg",
              quality: G_FILE_COMPRESSION
            });
          } catch (error) {
            iFile = new Blob([fReader.result], { type: file.type });
          }
        } else
          iFile = new Blob([fReader.result], { type: file.type });

        img.src = URL.createObjectURL(iFile);
        URL.revokeObjectURL(iFile);
        delete fReader.result;

        img.onload = function () {
          file.width = img.width;
          file.height = img.height;
          file.aRatio = file.width / file.height;
          file.orientation =
            file.width >= file.height ? "landscape" : "portrait";

          resolve(setNewImageDatabasePreview(img, file));
        };
      };
    } catch (error) {
      // eslint-disable-next-line no-console
      console.error(error);
      reject(error);
    }
  });
}

/* FOR ADD EXTRA SINGLE IMAGE TEMPLATES CROPPING */
export async function readNewUrlFile(file) {
  return new Promise((resolve, reject) => {
    try {
      let filex = {};
      let img = new Image();
      img.crossOrigin = '*';
      img.src = file.image;

      img.onload = function () {

        filex.width = file.width;
        filex.height = file.height;
        filex.aspectRatio = filex.width / filex.height;
        filex.cropped = false;
        filex.scaleX = 1;
        filex.scaleY = 1;

        filex.orientation =
          filex.width >= filex.height ? "landscape" : "portrait";

        resolve(setNewSimpleCanvasExtraImage(img, filex));
      };
    } catch (error) {
      // eslint-disable-next-line no-console
      console.error(error);
      reject(error);
    }
  });
}

/* FOR BACKGROUNDS AND FRAMES AUTOMATIC ROTATION */
export async function readAndRotateUrlFile(file, withCoords) {
  return new Promise((resolve, reject) => {
    try {
      let img = new Image();
      img.crossOrigin = "*";
      img.src = file.image;
      img.onload = function () {
        let canvas = document.createElement("canvas"),
          ctx = canvas.getContext("2d");

        canvas.width = file.height;
        canvas.height = file.width;

        let point = { x: 0, y: 0 };
        if (withCoords) {
          // izračun začetne točke coordinates
          point = { x: file.coordinates.left - (file.coordinates.width / 2), y: file.coordinates.top + (file.coordinates.height / 2) };
        }

        ctx.save();
        ctx.translate(canvas.width / 2, canvas.height / 2);

        ctx.rotate((Math.PI / 180) * 90);
        ctx.translate(-file.width / 2, -file.height / 2);

        const matrix = ctx.getTransform();

        let transformedPoint = { x: 0, y: 0 };
        if (withCoords) {
          transformedPoint = {
            x: (matrix.a * point.x + matrix.c * point.y + matrix.e) + file.coordinates.height / 2,
            y: (matrix.b * point.x + matrix.d * point.y + matrix.f) + file.coordinates.width / 2,
          };
        }

        //console.log(transformedPoint);

        ctx.drawImage(img, 0, 0, file.width, file.height);
        ctx.restore();

        let image = {
          attr: transformedPoint,
          path: file.fType == "image/png" ? canvas.toDataURL("image/png", G_FILE_COMPRESSION) : canvas.toDataURL("image/jpeg", G_FILE_COMPRESSION),
        };

        canvas.width = canvas.height = 0;
        ctx = null;
        canvas = null;
        resolve(image);
      };
    } catch (error) {
      // eslint-disable-next-line no-console
      console.error(error);
      reject(error);
    }
  });
}

/* GET IMAGE DIMENSIONS */
export async function readImageDimensions(file) {
  return new Promise((resolve, reject) => {
    try {
      let fReader = new FileReader();
      fReader.readAsArrayBuffer(file);

      fReader.onerror = () => {
        reject(fReader.error);
      };

      fReader.onload = async () => {
        let img = new Image();
        img.crossOrigin = '*';

        let iFile = "";
        if ((file.name.toLowerCase().indexOf('.heic') !== -1) || (file.name.toLowerCase().indexOf('.heif') !== -1)) {
          let blobURL = URL.createObjectURL(file);
          let blobRes = await fetch(blobURL)
          let blob = await blobRes.blob()
          try { // nekatere heic imajo type že image/jpeg, zato ob spodleteli konverziji obravnavamo kot navaden fajl
            iFile = await heic2any({
              blob,
              toType: "image/jpeg",
              quality: G_FILE_COMPRESSION
            });
          } catch (error) {
            iFile = new Blob([fReader.result], { type: file.type });
          }
        } else
          iFile = new Blob([fReader.result], { type: file.type });

        img.src = URL.createObjectURL(iFile);
        URL.revokeObjectURL(iFile);
        delete fReader.result;

        img.onload = function () {
          file.width = img.width;
          file.height = img.height;
          file.aspectRatio = file.width / file.height;
          file.orientation =
            file.width >= file.height ? "landscape" : "portrait";
          resolve(file);
        };
      };
    } catch (error) {
      // eslint-disable-next-line no-console
      console.error(error);
      reject(error);
    }
  });
}

/* GET IMAGE DIMENSIONS */
export async function readImageDimensionsWithSrc(file) {
  return new Promise((resolve, reject) => {
    try {
      let fReader = new FileReader();
      fReader.readAsArrayBuffer(file);

      fReader.onerror = () => {
        reject(fReader.error);
      };

      fReader.onload = async () => {
        let img = new Image();
        img.crossOrigin = '*';

        let iFile = "";
        if ((file.name.toLowerCase().indexOf('.heic') !== -1) || (file.name.toLowerCase().indexOf('.heif') !== -1)) {
          let blobURL = URL.createObjectURL(file);
          let blobRes = await fetch(blobURL)
          let blob = await blobRes.blob()
          try { // nekatere heic imajo type že image/jpeg, zato ob spodleteli konverziji obravnavamo kot navaden fajl
            iFile = await heic2any({
              blob,
              toType: "image/jpeg",
              quality: G_FILE_COMPRESSION
            });
          } catch (error) {
            iFile = new Blob([fReader.result], { type: file.type });
          }
        } else
          iFile = new Blob([fReader.result], { type: file.type });

        img.src = URL.createObjectURL(iFile);
        URL.revokeObjectURL(iFile);
        delete fReader.result;

        img.onload = function () {
          file.width = img.width;
          file.height = img.height;
          file.aspectRatio = file.width / file.height;
          file.orientation =
            file.width >= file.height ? "landscape" : "portrait";
          resolve(setNewSimpleCanvasExtraImage(img, file));
        };
      };
    } catch (error) {
      // eslint-disable-next-line no-console
      console.error(error);
      reject(error);
    }
  });
}

export function setNewSimpleCanvasImage(img, width, height, type) {
  let canvas = document.createElement("canvas");
  let ctx = canvas.getContext("2d");
  ctx.fillStyle = "white";
  ctx.fillRect(0, 0, 200, 200);

  canvas.width = width;
  canvas.height = height;
  ctx.drawImage(img, 0, 0, canvas.width, canvas.height);

  let image = canvas.toDataURL(type, G_FILE_COMPRESSION);

  canvas.width = canvas.height = 0;
  ctx = null;
  canvas = null;

  return { image };
}

export async function setNewSimpleCanvasExtraImage(img, file) {
  return new Promise((resolve, reject) => {
    try {
      let canvas = document.createElement("canvas");
      let ctx = canvas.getContext("2d");
      ctx.fillStyle = "white";
      ctx.fillRect(0, 0, 200, 200);

      canvas.width = file.width;
      canvas.height = file.height;
      ctx.drawImage(img, 0, 0, canvas.width, canvas.height);

      let image = {
        attr: file,
        path: file.type == "image/png" ? canvas.toDataURL("image/png", G_FILE_COMPRESSION) : canvas.toDataURL("image/jpeg", G_FILE_COMPRESSION)
      };

      canvas.width = canvas.height = 0;
      ctx = null;
      canvas = null;

      resolve({ image });
    } catch (error) {
      // eslint-disable-next-line no-console
      console.error(error);
      reject(error);
    }
  });
}

export function setNewImageDatabasePreview(img, file) {
  let canvas = document.createElement("canvas");
  let ctx = canvas.getContext("2d");
  ctx.fillStyle = "white";
  ctx.fillRect(0, 0, 200, 200);

  canvas.width = 400;
  canvas.height = 400 * (file.height / file.width);
  ctx.drawImage(img, 0, 0, canvas.width, canvas.height);

  let image = {
    attr: file,
    path: file.type == "image/png" ? canvas.toDataURL("image/png", G_FILE_COMPRESSION).replace(/^data:image\/png;base64,/, "") : canvas.toDataURL("image/jpeg", G_FILE_COMPRESSION).replace(/^data:image\/jpeg;base64,/, ""),
  };

  canvas.width = canvas.height = 0;
  ctx = null;
  canvas = null;

  return { image };
}

export async function readNewFile(file, mode) {
  // najprej dobimo EXIF orientation, potem sliko preberemo in primerno obrnemo, če je potrebno
  /*let orient = 0;
  if (file.type == "image/jpeg") {
    orient = await exifr.orientation(file);
    file.exif = orient != undefined ? orient : 0;
  } else*/ file.exif = 0;
  //console.log("DEBUG =>", file.selectedPaperType, file.selectedPaperTypeFile);

  return new Promise(async (resolve, reject) => {
    try {
      let fReader = new FileReader();
      fReader.readAsArrayBuffer(file);

      fReader.onerror = () => {
        reject(fReader.error);
      };

      fReader.onload = async () => {
        let img = new Image();

        img.crossOrigin = '*';
        /*if (file.exif > 1) {
          resetOrientation(fReader.result, file.exif, function(reset) {
            img.src = reset;
          });
        } else*/

        let iFile = "";
        if ((file.name.toLowerCase().indexOf('.heic') !== -1) || (file.name.toLowerCase().indexOf('.heif') !== -1)) {
          let blobURL = URL.createObjectURL(file);
          let blobRes = await fetch(blobURL)
          let blob = await blobRes.blob()
          try { // nekatere heic imajo type že image/jpeg, zato ob spodleteli konverziji obravnavamo kot navaden fajl
            iFile = await heic2any({
              blob,
              toType: "image/jpeg",
              quality: G_FILE_COMPRESSION
            });
          } catch (error) {
            iFile = new Blob([fReader.result], { type: file.type });
          }
        } else
          iFile = new Blob([fReader.result], { type: file.type });

        img.src = URL.createObjectURL(iFile);
        URL.revokeObjectURL(iFile);
        delete fReader.result;

        img.onload = function () {
          file.width = img.width;
          file.height = img.height;
          file.aspectRatio = file.width / file.height;
          file.cropped = false;
          file.scaleX = 1;
          file.scaleY = 1;

          file.orientation =
            file.width >= file.height ? "landscape" : "portrait";

          // dobimo velikost formata iz baze imageSize in zapišemo ustrezno velikost
          if (file.width >= file.height) {
            file.sWidth = store.state.storeImageSize.imageSize.find(
              (item) => item.name == file.selectedFormat
            ).sizeX;
            file.sHeight = store.state.storeImageSize.imageSize.find(
              (item) => item.name == file.selectedFormat
            ).sizeY;
          } else {
            file.sWidth = store.state.storeImageSize.imageSize.find(
              (item) => item.name == file.selectedFormat
            ).sizeY;
            file.sHeight = store.state.storeImageSize.imageSize.find(
              (item) => item.name == file.selectedFormat
            ).sizeX;
          }

          file.aspectRatioStore = file.sWidth / file.sHeight;

          // izračunamo store velikost slike (če je večja resolucija, se zmanjša, sicer povečamo)          
          if (file.aspectRatio >= 1) {
            const realAR = file.width / file.height;
            file.cWidth = parseInt(file.sHeight * realAR);
            file.cHeight = Number(file.sHeight);
          } else {
            const realAR = file.height / file.width;
            file.cHeight = parseInt(file.sWidth * realAR);
            file.cWidth = Number(file.sWidth);
          }

          file.fitWidth = Number(file.sWidth);
          file.fitHeight = Number(file.sHeight);

          // izračunamo procent kvalitete slike
          file.qualityPct = parseInt(
            Math.round(
              (file.width * file.height * 100) /
              (file.sWidth * file.sHeight) /
              20
            ).toFixed(0)
          );

          if (mode == "add") {
            count++;
            store.dispatch("readingImages", count);
            store.dispatch("filesMBSize", file.size);
            store.dispatch("filesMBLimit", file.size);
          }

          resolve(
            setNewCanvasImage(
              img,
              file.aspectRatio,
              file.aspectRatioStore,
              file.cWidth,
              file.cHeight,
              file.selectedPrintDate,
              file.lastModified,
              file.selectedFitIn,
              file.fitWidth,
              file.fitHeight
            )
          );

          //resolve(img);
        };

        img.onerror = () => {
          resolve(setNewCanvasImage(
            "",
            1,
            1,
            250,
            250,
            false,
            "",
            "", 1, 1
          ));
        };
      };
    } catch (error) {
      // eslint-disable-next-line no-console
      console.error(error);
      reject(error);
    }
  });
}

function drawTextBG(ctx, txt, font, x, y) {
  /// lets save current state as we make a lot of changes
  ctx.save();
  /// set font
  ctx.font = font;
  /// draw text from top - makes life easier at the moment
  ctx.textBaseline = "top";
  /// color for background
  ctx.fillStyle = "black";
  /// get width of text
  var width = ctx.measureText(txt).width + 15;
  /// draw background rect assuming height of font
  ctx.globalAlpha = 0.3;
  ctx.fillRect(x - 8, y - 5, width, parseInt(font, 10) + 6);
  ctx.globalAlpha = 1;
  /// text color
  ctx.fillStyle = "white";
  /// draw text on top
  ctx.fillText(txt, x, y);
  /// restore original state
  ctx.restore();
}

function drawTextBGPreview(ctx, txt, font, x, y) {
  /// lets save current state as we make a lot of changes
  ctx.save();
  /// set font
  ctx.font = font;
  /// draw text from top - makes life easier at the moment
  ctx.textBaseline = "top";
  /// color for background
  ctx.fillStyle = "black";
  /// get width of text
  let width = ctx.measureText(txt).width + 12;
  /// draw background rect assuming height of font
  ctx.globalAlpha = 0.3;
  ctx.fillRect(x - 6, y - 3, width, parseInt(font, 10) + 5);
  ctx.globalAlpha = 1;
  /// text color
  ctx.fillStyle = "white";
  /// draw text on top
  ctx.fillText(txt, x, y);
  /// restore original state
  ctx.restore();
}

export function setNewCanvasImage(
  img,
  aspectRatio,
  aspectRatioStore,
  cWidth,
  cHeight,
  selectedPrintDate,
  lastModified,
  selectedFitIn,
  fitWidth,
  fitHeight
) {
  let image = "";
  let thumb = "";
  let dPct = 0; // izračun, koliko procentov slike bo potrebno odrezati za FILL-IN
  let err = true;
  let canvas = document.createElement("canvas");
  let fitW = 0;
  let fitH = 0;
  let offset = 0;

  if (canvas.getContext) {
    let ctx = canvas.getContext("2d");
    if (img != "") {
      if (selectedFitIn == "FIT-IN") {
        if (aspectRatioStore > 1) {
          let asp = aspectRatioStore / aspectRatio;
          fitW = cWidth * asp;
          fitH = cHeight * asp;

          // najmanjša možna slika
          canvas.width = fitWidth;
          canvas.height = fitHeight;

          ctx.fillStyle = "white";
          ctx.fillRect(0, 0, canvas.width, canvas.height);

          if (aspectRatio > aspectRatioStore) {
            offset = (fitHeight - fitH) / 2;
            ctx.drawImage(img, 0, offset, canvas.width, canvas.height - (offset * 2));

            //console.log("Ležeča, večji aspect", fitW, fitH, fitWidth, fitHeight, offset);
          } else {
            offset = (fitH - fitHeight) / 2;
            ctx.drawImage(img, offset, 0, canvas.width - (offset * 2), canvas.height);

            //console.log("Ležeča, manjši aspect", fitW, fitH, fitWidth, fitHeight, offset);
          }
        } else {
          let asp = aspectRatio / aspectRatioStore;
          fitW = cWidth * asp;
          fitH = cHeight * asp;

          // najmanjša možna slika
          canvas.width = fitWidth;
          canvas.height = fitHeight;

          ctx.fillStyle = "white";
          ctx.fillRect(0, 0, canvas.width, canvas.height);

          if (aspectRatio < aspectRatioStore) {
            offset = (fitWidth - fitW) / 2;
            ctx.drawImage(img, offset, 0, canvas.width - (offset * 2), canvas.height);

            //console.log("Pokončna, večji aspect", cWidth, cHeight, fitW, fitH, fitWidth, fitHeight, offset);
          } else {
            offset = (fitW - fitWidth) / 2;
            ctx.drawImage(img, 0, offset, canvas.width, canvas.height - (offset * 2));

            //console.log("Pokončna, manjši aspect", fitW, fitH, fitWidth, fitHeight, offset);
          }
        }
      } else {
        // najmanjša možna slika
        canvas.width = cWidth;
        canvas.height = cHeight;

        ctx.fillStyle = "white";
        ctx.fillRect(0, 0, canvas.width, canvas.height);

        ctx.drawImage(img, 0, 0, canvas.width, canvas.height);
      }
    }

    if (img != "") {
      // datum izpišemo, če je izbran in prebran datum starejši od 60 sekund (ker prazen vrne trenutni čas, kar je napačno)
      if (selectedPrintDate && Date.now() - lastModified > 60000) {
        // kje narišemo datum glede na dolžine stranic
        if (aspectRatio >= aspectRatioStore) {
          drawTextBG(
            ctx,
            moment(lastModified).format(
              store.state.storeClient.client.environmentSettings.dateFormat
            ),
            "40px Arial bold",
            canvas.width / 2 - 60,
            canvas.height - 100
          );
        } else {
          ctx.translate(canvas.width - 80, canvas.height / 2 + 100);
          ctx.rotate(-0.5 * Math.PI);
          drawTextBG(
            ctx,
            moment(lastModified).format(
              store.state.storeClient.client.environmentSettings.dateFormat
            ),
            "40px Arial bold",
            0,
            0
          );
        }
      }
    }

    image = canvas.toDataURL("image/jpeg", G_FILE_COMPRESSION);

    // thumb    
    if (img != "") {
      if (selectedFitIn == "FIT-IN") {
        canvas.width = 150;
        canvas.height = 150;
        ctx.fillStyle = "white";

        //ctx.drawImage(img, 0, 0, canvas.width, canvas.height);

        if (aspectRatioStore > 1) {
          let ratio = 150 / fitWidth;
          let offset2 = 150 - (fitHeight * ratio);
          let addRatio = offset * ratio;

          if (aspectRatio > aspectRatioStore) {
            ctx.fillRect(0, offset2 / 2, canvas.width, 150 - offset2);
            ctx.drawImage(img, 0, offset2 / 2 + addRatio, canvas.width, 150 - offset2 - (addRatio * 2));
            //console.log("Ležeča, večji aspect", offset, offset2, ratio, addRatio);
          } else {
            ctx.fillRect(0, offset2 / 2, canvas.width, 150 - offset2);
            ctx.drawImage(img, addRatio, offset2 / 2, canvas.width - (addRatio * 2), 150 - offset2);
            //console.log("Ležeča, manjši aspect", offset, offset2, ratio, addRatio);
          }
        } else {
          let ratio = 150 / fitHeight;
          let offset2 = 150 - (fitWidth * ratio);
          let addRatio = offset * ratio;

          if (aspectRatio < aspectRatioStore) {
            ctx.fillRect(offset2 / 2, 0, 150 - offset2, canvas.height);
            ctx.drawImage(img, offset2 / 2 + addRatio, 0, 150 - offset2 - (addRatio * 2), canvas.height);
            //console.log("Pokončna, večji aspect");
          } else {
            ctx.fillRect(offset2 / 2, 0, 150 - offset2, canvas.height);
            ctx.drawImage(img, offset2 / 2, addRatio, 150 - offset2, canvas.height - (addRatio * 2));
            //console.log("Pokončna, manjši aspect");
          }
        }
      } else {
        canvas.width = 150 * aspectRatio;
        canvas.height = 150;

        ctx.drawImage(img, 0, 0, canvas.width, canvas.height);
        ctx.fillStyle = "red";
        ctx.globalAlpha = 0.45;

        // FILL-IN
        if (aspectRatioStore > 1) {
          if (aspectRatio > aspectRatioStore) {
            let rOffset = (canvas.width - (150 * aspectRatioStore)) / 2;
            dPct = rOffset * 2 * 150;

            ctx.fillRect(0, 0, rOffset, 150);
            ctx.fillRect(canvas.width - rOffset, 0, canvas.width + 1, 150);
            //console.log("Ležeča, večji aspect", canvas.width, canvas.height, fitWidth, fitHeight, aspectRatio, aspectRatioStore);
          } else {
            let rOffset = (canvas.height * (1 - (cWidth / fitWidth))) / 2;
            dPct = rOffset * 2 * canvas.width;

            ctx.fillRect(0, 0, canvas.width + 1, rOffset);
            ctx.fillRect(0, canvas.height - rOffset, canvas.width + 1, canvas.height + 1);
            //console.log("Ležeča, manjši aspect", canvas.width, canvas.height, fitWidth, fitHeight, cWidth, cHeight, aspectRatio, aspectRatioStore, rOffset);
          }
        } else {
          if (aspectRatio < aspectRatioStore) {
            let rOffset = (150 * (1 - (fitHeight / cHeight))) / 2;
            dPct = rOffset * 2 * canvas.width;

            ctx.fillRect(0, 0, canvas.width, rOffset);
            ctx.fillRect(0, canvas.height - rOffset, 150, canvas.height + 1);
            //console.log("Pokončna, večji aspect", canvas.width, canvas.height, fitWidth, fitHeight, aspectRatio, aspectRatioStore, rOffset);
          } else {
            let rOffset = (canvas.width - (150 * aspectRatioStore)) / 2;
            dPct = rOffset * 2 * canvas.height;

            ctx.fillRect(0, 0, rOffset, canvas.height + 1);
            ctx.fillRect(canvas.width - rOffset, 0, canvas.width + 1, canvas.height + 1);
            //console.log("Pokončna, manjši aspect", canvas.width, canvas.height, fitWidth, fitHeight, cWidth, cHeight, aspectRatio, aspectRatioStore, rOffset);
          }
        }
      }

      // datum izpišemo, če je izbran in prebran datum starejši od 60 sekund (ker prazen vrne trenutni čas, kar je napačno)
      if (selectedPrintDate && Date.now() - lastModified > 60000) {
        // kje narišemo datum glede na dolžine stranic
        if (aspectRatio >= aspectRatioStore) {
          drawTextBGPreview(
            ctx,
            moment(lastModified).format(
              store.state.storeClient.client.environmentSettings.dateFormat
            ),
            "6px Arial bold",
            canvas.width / 2 - 18,
            canvas.height - 13
          );
        } else {
          ctx.translate(canvas.width - 13, canvas.height / 2 + 18);
          ctx.rotate(-0.5 * Math.PI);
          drawTextBGPreview(
            ctx,
            moment(lastModified).format(
              store.state.storeClient.client.environmentSettings.dateFormat
            ),
            "6px Arial bold",
            0,
            0
          );
        }
      }

      thumb = canvas.toDataURL("image/png", G_FILE_COMPRESSION);
    }

    canvas.width = canvas.height = 0;
    ctx = null;
    canvas = null;

    err = img == "" ? true : false; // sporočilo o napaki
  }
  return { thumb, image, dPct, err };
}

export function resetOrientation(srcBase64, srcOrientation, callback) {
  let img = new Image();
  img.crossOrigin = '*';

  img.onload = function () {
    let width = img.width,
      height = img.height,
      canvas = document.createElement("canvas"),
      ctx = canvas.getContext("2d");

    // set proper canvas dimensions before transform & export
    if (4 < srcOrientation && srcOrientation < 9) {
      canvas.width = height;
      canvas.height = width;
    } else {
      canvas.width = width;
      canvas.height = height;
    }

    // transform context before drawing image
    switch (srcOrientation) {
      case 2:
        ctx.transform(-1, 0, 0, 1, width, 0);
        break;
      case 3:
        ctx.transform(-1, 0, 0, -1, width, height);
        break;
      case 4:
        ctx.transform(1, 0, 0, -1, 0, height);
        break;
      case 5:
        ctx.transform(0, 1, 1, 0, 0, 0);
        break;
      case 6:
        ctx.transform(0, 1, -1, 0, height, 0);
        break;
      case 7:
        ctx.transform(0, -1, -1, 0, height, width);
        break;
      case 8:
        ctx.transform(0, -1, 1, 0, 0, width);
        break;
      default:
        break;
    }

    // draw image
    ctx.drawImage(img, 0, 0);
    // export base64
    callback(canvas.toDataURL("image/jpeg", G_FILE_COMPRESSION));
  };
  img.src = srcBase64;
}

export function resizeImage(base64Str, maxWidth = 400, maxHeight = 400) {
  return new Promise((resolve) => {
    let img = new Image()
    img.src = base64Str
    img.onload = () => {
      let canvas = document.createElement('canvas')
      const MAX_WIDTH = maxWidth
      const MAX_HEIGHT = maxHeight
      let width = img.width
      let height = img.height

      if (width > height) {
        if (width > MAX_WIDTH) {
          height *= MAX_WIDTH / width
          width = MAX_WIDTH
        }
      } else {
        if (height > MAX_HEIGHT) {
          width *= MAX_HEIGHT / height
          height = MAX_HEIGHT
        }
      }
      canvas.width = width
      canvas.height = height
      let ctx = canvas.getContext('2d')
      ctx.drawImage(img, 0, 0, width, height)
      resolve(canvas.toDataURL("image/jpeg", G_FILE_COMPRESSION))
    }
  })
}